import React from 'react';
import pt from 'prop-types';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import theme from './theme';

const Layout = ({ children }) => (
  <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
);

Layout.propTypes = {
  children: pt.node,
};

Layout.defaultProps = {
  children: [],
};

export default Layout;
